//请自行添加语言资源
const customer = {
  customerNo:'客户编号',
  customerName:'客户名称',
  customerType:'客户类型',
  customerSubclassType:'客户子类',
  createTime:"创建时间",
  creator:"创建用户",
  updateTime:"更新时间",
  updater:"更新用户",
  msg:{
  }
};
export default customer



// WEBPACK FOOTER //
// ./src/page/md/customer/lang/customer.zh.js